<template>
  <div>
    <div class="">
      <div
        v-for="file in files"
        :key="file.id"
        class="border p-4 relative mb-5 cursor-pointer zoom-in w-100"
      >
        <a :href="file.url_file" class="flex flex-row" target="_blank">
          <img
            :src="file.url_thumbnail"
            :alt="file.filename"
            class="w-12 h-12"
          />
          <div class="pl-2">
            <p class="break-all">
              {{
                file.filename_original
                  ? file.filename_original
                  : 'ไม่พบชื่อเกสาร'
              }}
            </p>
          </div>
        </a>
        <Tippy
          tag="div"
          content="Remove this image?"
          @click.prevent="removeFile(file.id)"
          class="w-5 h-5 flex items-center justify-center absolute rounded-full text-white bg-theme-6 right-0 top-0 -mr-2 -mt-2"
        >
          <xIcon class="w-4 h-4" />
        </Tippy>
      </div>
    </div>
    <div
      class="border-2 border-dashed dark:border-dark-5 rounded-md h-full border-theme-4"
    >
      <div class="px-4 flex items-center cursor-pointer relative h-40">
        <ImageIcon class="w-4 h-4 mr-2" />
        <span class="text-theme-1 dark:text-theme-10 mr-1">Browse</span>
        ลากและวางในกรอกสี่เหลี่ยม
        <input
          type="file"
          class="w-full h-40 top-0 left-0 absolute opacity-0"
          ref="file"
          multiple
          @change="attachFiles"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { useStore } from '@/store'
import { apiFile } from '@/utils/api'
import alert from '@/helpers/alert'

export default defineComponent({
  name: 'attach-file-upload',
  props: {
    module: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const store = useStore()
    const files = computed(() => store.state[props.module].files)
    const sizeKb = computed(() => store.state.global.fileUploadMaxSizeKb)
    const sizeMb = computed(() => store.state.global.fileUploadMaxSize)

    const attachFiles = async event => {
      const formData = new FormData()
      // let hasData = false
      for (let i = 0; i < event.target.files.length; i++) {
        // console.log(
        //   'files: ',
        //   event.target.files[i].name.length,
        //   event.target.files[i].name,
        //   event.target.files[i].size
        // )
        if (
          event.target.files[i].name.length <= 200 &&
          event.target.files[i].size <= sizeKb.value
        ) {
          // hasData = true
          formData.append('file[]', event.target.files[i])
        } else {
          if (event.target.files[i].name.length >= 200) {
            alert.error('ชื่อไฟล์ยาวเกิน 200 ตัวอักษร')
          } else if (event.target.files[i].size >= sizeKb.value) {
            alert.error(`ขนาดไฟล์ใหญ่เกิน ${sizeMb.value} MB`)
          }
        }
      }
      // console.log('formData: ', formData, formData.entries())
      if (formData.has('file[]')) {
        formData.append('module', props.module)
        await apiFile.post('/file/upload', formData).then(res => {
          if (res.data.code == 200) {
            for (const i in res.data.data) {
              store.commit(`${props.module}/setFile`, res.data.data[i])
            }
          }
        })
      }
    }

    const removeFile = async id => {
      await store.commit(`${props.module}/removeFile`, id)
    }

    return {
      props,
      files,
      attachFiles,
      removeFile
    }
  }
})
</script>

<style scoped></style>
